const openModal = () => {
    const consultButtons = document.querySelectorAll('.consult-button');
    const menuButton = document.getElementById('menu-button');
    const consultModal = document.getElementById('consult-menu');
    const menuModal = document.getElementById('modal-menu');
    const anotherAddressButtons = document.querySelectorAll('.another-address-button');
    const headerMoreMenuButton = document.querySelectorAll('.midle-header__item-more ');
    const headerMoreMenu = document.getElementById('header-more-list');
    const anotherAddressModal = document.getElementById('modal-address');
    const tariffsButton = document.querySelectorAll('.free-consult__sent-button')
    const openReviewModalButtons = document.querySelectorAll('.review-open-button');
    const reviewModal = document.getElementById('review-modal');
    const closeReviewSuccessModal = document.getElementById('close-review-success-modal')
    const reviewSuccessModal = document.getElementById('review-success-modal');
    const closeFreeConsultationModal = document.getElementById('close-free-consultation-modal')
    const freeConsultationModal = document.getElementById('free-consultation-modal');
    const tariffModal = document.getElementById('tariff-modal');
    const tariffButtons = document.querySelectorAll('.tariffButton');
    const activeClass = 'active';
    const closePopupsBtn = document.querySelectorAll('.modal-close-circle');

    const closeAllModals = () => {
        consultModal.classList.remove(activeClass);
        menuModal.classList.remove(activeClass);
        consultButtons.forEach(el => el.classList.remove(activeClass));
        menuButton.classList.remove(activeClass);
        anotherAddressModal && anotherAddressModal.classList.remove(activeClass);
        reviewModal.classList.remove(activeClass);
        reviewSuccessModal.classList.remove(activeClass);
        freeConsultationModal.classList.remove(activeClass);
        tariffModal.classList.remove(activeClass);
    }


    closePopupsBtn.forEach((closeBtn) =>{
        closeBtn.addEventListener('click', closeAllModals);
    });

    const closeTariffModal = document.getElementById('close-tariff-modal');
    if (closeTariffModal) {
        document.getElementById('close-tariff-modal').onclick = function () {
            document.getElementById('tariff-modal').classList.remove('active');
        };
    }


    let hideTimeout;
    headerMoreMenuButton.forEach(button => {
        button.addEventListener('mouseenter', () => {
            clearTimeout(hideTimeout);
            headerMoreMenu.classList.add('active');
        });

        button.addEventListener('mouseleave', () => {
            hideTimeout = setTimeout(() => {
                headerMoreMenu.classList.remove('active');
            }, 300);
        });
    });


    headerMoreMenu && headerMoreMenu.addEventListener('mouseenter', () => {
        clearTimeout(hideTimeout);
    });
    headerMoreMenu && headerMoreMenu.addEventListener('mouseleave', () => {
        hideTimeout = setTimeout(() => {
            headerMoreMenu.classList.remove('active');
        }, 300);
    });

    // freeConsultationButton.addEventListener('click', () => {
    //     const currentDisplay = window.getComputedStyle(freeConsultationModal).display;
    //     freeConsultationModal.style.display = currentDisplay === 'none' ? 'flex' : 'none';
    // });

    consultButtons && consultButtons.forEach(consultButton => {
        consultButton.addEventListener('click', () => {
            const formSuccess = consultModal.querySelector('.form-data__result');
            const form = consultModal.querySelector('.form-data__input');
            if (consultModal.classList.contains(activeClass)) {
                closeAllModals();
            } else {
                closeAllModals();
                consultModal.classList.add(activeClass);
                consultButton.classList.add(activeClass);
                form.classList.remove('hide');
                formSuccess.classList.add('hide');
            }
        });
    })

    menuButton && menuButton.addEventListener('click', () => {
        if (menuModal.classList.contains(activeClass)) {
            closeAllModals();
        } else {
            closeAllModals();
            menuModal.classList.add(activeClass);
            menuButton.classList.add(activeClass);
        }
    });

    // код для изменения адреса
    anotherAddressButtons.forEach(button => {
        button.addEventListener('click', () => {
            if (anotherAddressModal.classList.contains(activeClass)) {
                closeAllModals();
            } else {
                closeAllModals();
                anotherAddressModal.classList.add(activeClass);
            }
        });
    });

    openReviewModalButtons && openReviewModalButtons.forEach(el => {
        el.addEventListener('click', () => {
            if (reviewModal.classList.contains(activeClass)) {
                closeAllModals();
            } else {
                closeAllModals();
                reviewModal.classList.add(activeClass);
            }
        });
    })

    tariffButtons && tariffButtons.forEach(tariffButton => {
        tariffButton.addEventListener('click', () => {
            const formSuccess = tariffModal.querySelector('.form-data__result');
            const form = tariffModal.querySelector('.form-data__input');
            const message = form.querySelector('.message')
            if (tariffModal.classList.contains(activeClass)) {
                closeAllModals();
            } else {
                closeAllModals();
                message.innerHTML = '';
                tariffModal.classList.add(activeClass);
                tariffButton.classList.add(activeClass);
                form.classList.remove('hide');
                formSuccess.classList.add('hide');
            }
        });
    })

    tariffsButton && tariffsButton.forEach(el => {
        el.addEventListener('click', () => closeAllModals());
    })

    closeReviewSuccessModal && closeReviewSuccessModal.addEventListener('click', () => closeAllModals());
    closeFreeConsultationModal && closeFreeConsultationModal.addEventListener('click', () => closeAllModals());

    menuModal && menuModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    consultModal && consultModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    anotherAddressModal && anotherAddressModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    reviewModal && reviewModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    reviewSuccessModal && reviewSuccessModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    freeConsultationModal && freeConsultationModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })

    tariffModal && tariffModal.addEventListener('click', e => {
        if (e.target == e.currentTarget) {
            closeAllModals();
        }
    })
}

const consultForm = () => {
    const forms = document.querySelectorAll('.consult-form');

    forms.forEach(el => {
        const form = el;
        const timeSelect = form.querySelector('.select-js');
        const consultText = form.querySelector('.free-consult__sent-time__text');

        if (timeSelect && consultText){
            form.addEventListener('submit', (e) => {
                consultText.textContent = timeSelect.value
            });
        }
    });
}

const init = () => {
    openModal();
    consultForm();
}

document.addEventListener('DOMContentLoaded', init);
